import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-success-change-password',
  templateUrl: './dialog-success-change-password.component.html',
  styleUrls: ['./dialog-success-change-password.component.scss']
})
export class SuccessChangePasswordDialog {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }
}
